var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-container"},[_c('h1',{staticClass:"home-title"},[_vm._v(_vm._s(_vm.$t("Welcome to your SMR platform")))]),_c('img',{staticClass:"img-responsive",attrs:{"src":"/img/accueil.jpeg"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }